var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7258 2.42861L2.30749 14.7111C2.08948 14.911 1.96289 15.1966 1.96289 15.4966L1.96289 28.1004C1.96289 28.6859 2.42705 29.1572 3.00372 29.1572L13.0182 29.1572C13.0393 29.1572 13.0534 29.1429 13.0534 29.1215V23.7444C13.0534 21.9306 14.3544 20.3024 16.1337 20.1453C18.138 19.9668 19.8188 21.5664 19.8188 23.5659V29.1215C19.8188 29.1429 19.8328 29.1572 19.8539 29.1572H29.3129C29.8895 29.1572 30.3537 28.6859 30.3537 28.1004V15.4823C30.3537 15.1895 30.2341 14.911 30.0232 14.7111L17.1323 2.44289C16.7385 2.06442 16.1266 2.06442 15.7258 2.42861Z",
    stroke: "#262626",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/IconHome.903eda5a5e01bd15d784f148866840a1.svg";
export { ForwardRef as ReactComponent };